export const BYTES_PER_GB = 1024 * 1024 * 1024;

export function toStorageLimitBytes(storageGb: number): number {
    return Math.max(0, Number(storageGb || 0)) * BYTES_PER_GB;
}

export function normalizeStorageBytes(value?: number | null): number {
    const numeric = Number(value || 0);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : 0;
}

export function formatStorageSize(bytes?: number | null): string {
    const normalized = normalizeStorageBytes(bytes);

    if (normalized === 0) return '0 B';

    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let value = normalized;
    let index = 0;

    while (value >= 1024 && index < units.length - 1) {
        value /= 1024;
        index += 1;
    }

    const fractionDigits = value >= 10 || index === 0 ? 0 : 1;
    return `${value.toFixed(fractionDigits)} ${units[index]}`;
}
